import { alpha, Stack, Typography } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import { HighlightMatches } from './searchMatching';
import { SuggesterPopoverMode, VariableCompletion } from './types';

type MenuItemContentFieldProps = {
  fieldCompletion: VariableCompletion;
  search: string;
  mode?: SuggesterPopoverMode;
};

export const MenuItemContentField = ({
  search,
  fieldCompletion,
  mode,
}: MenuItemContentFieldProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      data-cy="template-suggester-field"
    >
      {fieldCompletion.renderIcon ? (
        <Stack
          sx={{
            border: '1px solid',
            borderColor: t => alpha(t.palette.text.disabled, 0.15),
            width: 36,
            height: 36,
            borderRadius: borderRadius('xl'),
            color: 'text.secondary',
          }}
          alignItems="center"
          justifyContent="center"
        >
          {fieldCompletion.renderIcon()}
        </Stack>
      ) : null}
      <Stack>
        <Typography variant="body2">
          <HighlightMatches search={search} text={fieldCompletion.caption} />
        </Typography>
        <Typography
          variant="caption"
          color="info.main"
          sx={{
            // TODO: add "code" variant to MUI typography
            fontFamily:
              "Monaco, Menlo, 'Ubuntu Mono', Consolas, 'Source Code Pro', source-code-pro, monospace",
          }}
        >
          <HighlightMatches
            search={search}
            text={`${fieldCompletion.meta}.${fieldCompletion.value}`}
            mode={mode}
          />
        </Typography>
      </Stack>
    </Stack>
  );
};
